import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import BrandLogo from '../shared/BrandLogo';

const OnboardingHeader = () => {
    return (
        <>   
            {/*MOBILE*/}
            <div className="d-block d-lg-none mb-3">
                <Navbar fixed="top" collapseOnSelect expand="md" variant="dark" className="navbar-glass">
                    <Container fluid>
                        <Navbar.Brand>
                            <BrandLogo />
                        </Navbar.Brand>
                    </Container>
                </Navbar>
            </div>

            {/*DESKTOP*/}
            <div className="d-lg-block d-none mb-3">
                <Navbar fixed="top" collapseOnSelect expand="lg" variant="dark" className="navbar-glass">
                    <Container fluid>
                        <Navbar.Brand>
                            <BrandLogo />
                        </Navbar.Brand>
                    </Container>
                </Navbar>
            </div>
        </>
    );
};

export default OnboardingHeader;

